import { Component, OnInit, Optional } from '@angular/core';

import { IonNav, ModalController } from '@ionic/angular';

import { IAssetInformation } from '@models/types';

@Component({
    selector: 'app-page-asset-information-modal',
    templateUrl: 'asset-information-modal.page.html',
    styleUrls: ['asset-information-modal.page.scss'],
})
export class AssetInformationModalPage implements OnInit {
    public state: Partial<IAssetInformation> = { isQuestion: false };
    public isDataLoaded = false;

    constructor(
        private modalController: ModalController,
        @Optional() private nav: IonNav
    ) { }

    ngOnInit() { }

    ionViewWillEnter() {
        if (this.nav?.rootParams) {
            // Multi assets with same identifier
            this.state.multipleAssetsWithSameIdentifier = true;
        } else {
            // Single asset
            this.state.multipleAssetsWithSameIdentifier = false;
        }

        this.isDataLoaded = true;
    }

    public async closeModal() {
        await this.modalController.dismiss();
    }
}
